import { http, setFormData } from '@/utils/http'
import { AID_FETCH, AID_CREATE, AID_UPDATE } from '@/store/actions/aid'

const state = {
  aids: []
}

const getters = {
  aids: (state, g, rS, rootGetters) => {
    const aids = state.aids.map(aid => {
      aid.state = rootGetters.stateName(aid.state_id)
      aid.agency = rootGetters.agencyName(aid.agency_id)
      aid.location = rootGetters.locationField('name', aid.location_id)
      aid.lga = rootGetters.locationField('tag', aid.location_id)
      aid.event = rootGetters.eventField('title', aid.event_id)
      return aid
    })

    return aids
  },
  aidsByField: state => (field, value) => state.aids.filter(aid => aid[field] === value)
}

const mutations = {
  [AID_FETCH]: (state, payload) => {
    state.aids = [ ...payload ]
  },
  [AID_UPDATE]: (state, payload) => {
    const updatedAids = state.aids.map(
      aid => (aid._id === payload._id ? Object.assign(aid, payload) : aid)
    )
    state.aids = updatedAids
  }
}

const actions = {
  [AID_FETCH]: ({ commit }) => {
    return new Promise((resolve, reject) => {
      http.get('aid/read_all')
        .then(({ data: response }) => {
          if (response.code === 200) {
            commit(AID_FETCH, response.data)
            resolve(response)
          }
          else reject(response)
        })
    })
  },
  [AID_CREATE]: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      const params = setFormData(payload)
      http.post('aid/create', params)
        .then(({ data: response }) => {
          if (response.code === 200) resolve(response)
          else reject(response)
        })
    })
  },
  [AID_UPDATE]: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      const params = setFormData(payload)
      http.post('aid/update', params)
        .then(({ data: response }) => {
          if (response.code === 200) {
            commit(AID_UPDATE, payload)
            resolve(payload)
          }
          else reject(response)
        })
    })
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
